import React, { useEffect } from 'react';
import { UserAuth } from 'store/auth';
import { useAppSelector } from 'store/hooks';
import { useMiNavigation } from 'hooks/useNavigation';

export default function BlankRouter() {
    const navigate = useMiNavigation();
    const userAuth: UserAuth = useAppSelector((state) => state.auth);

    useEffect(() => {
        if (userAuth) {
            if ('' == (userAuth.topMenu?.customDomainApp ?? ''))
                navigate((userAuth?.userInfo?.homeUrl ?? '/home') + window.location.search + window.location.hash);
            else {
                navigate(
                    '/p/' + userAuth.topMenu?.customDomainApp + '/' + window.location.search + window.location.hash,
                );
            }
        }
    }, []);

    return <div></div>;
}
